import { Component, h, page } from 'pylevate-runtime';
import { AcceptInvite } from '../ui/public.js';
export class Invite extends Component {
  render(props, state, context) {
    const children = props && props.children;
    return h('div', null, h(AcceptInvite, {token: this.props.token}));
  }
}
Invite = page({title: 'Joining a workspace — Uplevate', route: '/invite/:token'})(Invite);
